export const MAX_PHOTOS = 3;